import React from 'react';
import './FormField.scss';

interface OptionType {
  value: string;
  label: string;
}

interface Props {
  error: string;
  label: string;
  type: string;
  disabled?: boolean;
  value?: string;
  handleField: (e:
    React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => void;
  placeholder?: string;
  options?: OptionType[]
}

function FormField({
  error,
  label,
  type,
  disabled,
  value,
  handleField,
  placeholder = '',
  options = [],
}: Props) {
  return (
    <div className="formField">
      <label className="formField-label">{label}</label>
      {/* eslint-disable-next-line no-nested-ternary */}
      {type === 'textarea' ? (
        <textarea
          disabled={disabled}
          value={value}
          onChange={(e) => handleField(e)}
          placeholder={placeholder}
          className="formField-textarea"
        />
      ) : type === 'select' ? (
        <select
          disabled={disabled}
          value={value}
          onChange={(e) => handleField(e)}
          className="formField-select"
        >
          <option value="">
            Select
            {label}
          </option>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      ) : (
        <input
          type={type}
          disabled={disabled}
          value={value}
          onChange={(e) => handleField(e)}
          autoComplete="off"
          placeholder={placeholder}
        />
      )}

      <div style={{ textAlign: 'right' }}>
        {error && <div className="error">{error}</div>}
      </div>
    </div>
  );
}

export default FormField;
